import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import {
  ElementTypeCategoriesDto,
  ScenarioProfileDto,
} from '@cloud-twin-v2/generated/simulation.generated.client';
import { MapStep } from '@common-modules/wlm-map/models/map-step';
import { MasterOperatorConnectItemsSettings } from '../../models/master-operator-connect-settings';
import { MasterOperatorService } from '../../services/master-operator.service';
import { ProfilesService } from '../../services/profiles.service';
import {
  ProfileChartPopupComponent,
  ProfileChartPopupConfiguration,
} from '../profile-chart-popup/profile-chart-popup.component';

const COMPONENT_SELECTOR = 'tc-profiles-list';
@Component({
    selector: COMPONENT_SELECTOR,
    templateUrl: './profiles-list.component.html',
    styleUrls: ['./profiles-list.component.scss'],
    standalone: false
})
export class ProfilesListComponent implements OnInit {
  private _connectSettings: MasterOperatorConnectItemsSettings;

  public get connectSettings(): MasterOperatorConnectItemsSettings {
    return this._connectSettings;
  }
  @Input() public set connectSettings(value: MasterOperatorConnectItemsSettings) {
    this._connectSettings = value;
    if (value) {
      this.loadProfiles(value);
    }
  }

  @Input() attributesMetadata: Map<string, ElementTypeCategoriesDto[]>;
  @Input() step: MapStep;

  isOpen = false;
  profileFormControl: FormControl;
  scenariosProfiles: ScenariosProfiles[];

  constructor(
    private _profileService: ProfilesService,
    private _profilePopup: MatDialog,
    private _masterOperatorService: MasterOperatorService
  ) {}

  ngOnInit(): void {}

  dropDown() {
    this.isOpen = !this.isOpen;
  }

  selectProfile(profile: ScenarioProfileDto, scenarioId: string) {
    const metadataKeys = Object.keys(this.attributesMetadata);

    const metadataKey = metadataKeys?.find((x) => x?.includes(scenarioId));

    let scenarioMetadata: ElementTypeCategoriesDto[] = [];
    if (metadataKey) {
      scenarioMetadata = this.attributesMetadata[metadataKey];
    }

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '865px';
    dialogConfig.height = '550px';
    const startDate = this.step.step;

    const chartParameters = new ProfileChartPopupConfiguration({
      startDate: startDate,
      scenarioId: scenarioId,
      attributesMetadata: scenarioMetadata,
      profileId: profile.id,
      name: profile.name,
    });

    dialogConfig.data = chartParameters;
    this._profilePopup.open(ProfileChartPopupComponent, dialogConfig);
  }

  private loadProfiles(connectSettings: MasterOperatorConnectItemsSettings) {
    this.isOpen = false;
    const scenarioIds = connectSettings.items.map((x) => x.scenarioId);
    this._profileService.getScenarioProfiles(scenarioIds).subscribe({
      next: (profilesByScenario) => {
        const scenarioIds = Object.keys(profilesByScenario.scenarioProfiles);

        const scenariosProfiles: ScenariosProfiles[] = [];
        scenarioIds.forEach((scenarioId) => {
          const connectionItem = connectSettings.items.find((x) => x.scenarioId === scenarioId);
          if (connectionItem) {
            const profiles = profilesByScenario.scenarioProfiles[scenarioId];
            const scenarioProfiles = new ScenariosProfiles({
              name: this._masterOperatorService.instanceReadableLabel(connectionItem),
              scenarioId,
              profiles,
            });
            scenariosProfiles.push(scenarioProfiles);
          }
        });
        this.scenariosProfiles = scenariosProfiles;
        this.initializeProfileForm();
      },
    });
  }

  private initializeProfileForm() {
    this.profileFormControl = new FormControl('');
  }
}

export class ScenariosProfiles {
  name: string;
  scenarioId: string;
  profiles: ScenarioProfileDto[];

  constructor(init: Partial<ScenariosProfiles>) {
    Object.assign(this, init);
  }
}
